import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5729de59"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row mt-10" }
const _hoisted_3 = { class: "col-xs-12 col-sm-4 col-md-4 col-lg-4 offset-sm-1 offset-md-1 offset-lg-1" }
const _hoisted_4 = { class: "fv-row mb-5" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-base ms-3 fw-bold text-dark" }, [
  /*#__PURE__*/_createTextVNode("VIN "),
  /*#__PURE__*/_createElementVNode("small", { class: "text-danger" }, "*")
], -1))
const _hoisted_6 = { class: "fv-plugins-message-container" }
const _hoisted_7 = { class: "fv-help-block" }
const _hoisted_8 = { class: "fv-row mb-5" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-base ms-3 fw-bold text-dark" }, [
  /*#__PURE__*/_createTextVNode("Marca "),
  /*#__PURE__*/_createElementVNode("small", { class: "text-danger" }, "*")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "Selecciona marca",
  selected: ""
}, " Selecciona la marca del vehículo ", -1))
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "fv-plugins-message-container" }
const _hoisted_13 = { class: "fv-help-block" }
const _hoisted_14 = { class: "fv-row mb-5" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-base ms-3 fw-bold text-dark" }, [
  /*#__PURE__*/_createTextVNode("Modelo "),
  /*#__PURE__*/_createElementVNode("small", { class: "text-danger" }, "*")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "Selecciona modelo",
  selected: ""
}, "Selecciona un modelo", -1))
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "fv-plugins-message-container" }
const _hoisted_19 = { class: "fv-help-block" }
const _hoisted_20 = { class: "fv-row mb-5" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-base ms-3 fw-bold text-dark" }, [
  /*#__PURE__*/_createTextVNode("Año "),
  /*#__PURE__*/_createElementVNode("small", { class: "text-danger" }, "*")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "Selecciona anio",
  selected: ""
}, " Selecciona el año del vehículo ", -1))
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "fv-plugins-message-container" }
const _hoisted_25 = { class: "fv-help-block" }
const _hoisted_26 = { class: "fv-row mb-5" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-base ms-3 fw-bold text-dark" }, [
  /*#__PURE__*/_createTextVNode("Versión "),
  /*#__PURE__*/_createElementVNode("small", { class: "text-danger" }, "*")
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "Selecciona version",
  selected: ""
}, " Selecciona una versión ", -1))
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "fv-plugins-message-container" }
const _hoisted_31 = { class: "fv-help-block" }
const _hoisted_32 = { class: "fv-row mb-5" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-base ms-3 fw-bold text-dark" }, [
  /*#__PURE__*/_createTextVNode("Color "),
  /*#__PURE__*/_createElementVNode("small", { class: "text-danger" }, "*")
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "Selecciona color",
  selected: ""
}, "Selecciona color", -1))
const _hoisted_35 = ["value"]
const _hoisted_36 = { class: "fv-plugins-message-container" }
const _hoisted_37 = { class: "fv-help-block" }
const _hoisted_38 = { class: "fv-row mb-5" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-base ms-3 fw-bold text-dark" }, [
  /*#__PURE__*/_createTextVNode("Transmisión "),
  /*#__PURE__*/_createElementVNode("small", { class: "text-danger" }, "*")
], -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = { style: {"display":"inline-flex","list-style-type":"none","padding":"0px"} }
const _hoisted_42 = { style: {"margin-right":"10px"} }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-base" }, "Manual", -1))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-base" }, "Automática", -1))
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = { class: "col-xs-12 col-sm-4 col-md-4 col-lg-4 offset-sm-1 offset-md-1 offset-lg-1" }
const _hoisted_48 = { class: "fv-row mb-5" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-base ms-3 fw-bold text-dark" }, [
  /*#__PURE__*/_createTextVNode("Carrocería "),
  /*#__PURE__*/_createElementVNode("small", { class: "text-danger" }, "*")
], -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "Selecciona carroceria",
  selected: ""
}, " Selecciona el tipo de carrocería ", -1))
const _hoisted_51 = ["value"]
const _hoisted_52 = { class: "fv-plugins-message-container" }
const _hoisted_53 = { class: "fv-help-block" }
const _hoisted_54 = { class: "fv-row mb-5" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-base ms-3 fw-bold text-dark" }, [
  /*#__PURE__*/_createTextVNode("Combustible "),
  /*#__PURE__*/_createElementVNode("small", { class: "text-danger" }, "*")
], -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "Selecciona combustible",
  selected: ""
}, " Selecciona el tipo de combustible ", -1))
const _hoisted_57 = ["value"]
const _hoisted_58 = { class: "fv-plugins-message-container" }
const _hoisted_59 = { class: "fv-help-block" }
const _hoisted_60 = { class: "fv-row mb-5" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-base ms-3 fw-bold text-dark" }, [
  /*#__PURE__*/_createTextVNode("Kilometraje "),
  /*#__PURE__*/_createElementVNode("small", { class: "text-danger" }, "*")
], -1))
const _hoisted_62 = { class: "fv-plugins-message-container" }
const _hoisted_63 = { class: "fv-help-block" }
const _hoisted_64 = { class: "fv-row mb-5" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-base ms-3 fw-bold text-dark" }, [
  /*#__PURE__*/_createTextVNode("¿Cuenta con certificado? "),
  /*#__PURE__*/_createElementVNode("small", { class: "text-danger" }, "*")
], -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_67 = { style: {"display":"inline-flex","list-style-type":"none","padding":"0px"} }
const _hoisted_68 = { style: {"margin-right":"10px"} }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-base" }, "Si", -1))
const _hoisted_70 = [
  _hoisted_69
]
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-base" }, "No", -1))
const _hoisted_72 = [
  _hoisted_71
]
const _hoisted_73 = { class: "fv-row mb-5" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-base ms-3 fw-bold text-dark" }, [
  /*#__PURE__*/_createTextVNode("Precio "),
  /*#__PURE__*/_createElementVNode("small", { class: "text-danger" }, "*")
], -1))
const _hoisted_75 = { class: "fv-plugins-message-container" }
const _hoisted_76 = { class: "fv-help-block" }
const _hoisted_77 = { class: "fv-row mb-5" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-base ms-3 fw-bold text-dark" }, [
  /*#__PURE__*/_createTextVNode("Días en piso "),
  /*#__PURE__*/_createElementVNode("small", { class: "text-danger" }, "*")
], -1))
const _hoisted_79 = { class: "input-group" }
const _hoisted_80 = { class: "input-group-text p-0" }
const _hoisted_81 = { class: "input-group-text p-0" }
const _hoisted_82 = { class: "fv-plugins-message-container" }
const _hoisted_83 = { class: "fv-help-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Form, {
      class: "form",
      id: "kt_vehicle_form",
      onInvalidSubmit: _ctx.onInvalidSubmit,
      onSubmit: _ctx.save,
      "validation-schema": _ctx.vehicle,
      ref: "newVehicleRef"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_Field, {
                  class: "form-control form-control-sm form-control-solid",
                  type: "text",
                  name: "vin",
                  ref: "vin",
                  modelValue: _ctx.initialValues.vin,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.initialValues.vin) = $event)),
                  autocomplete: "off",
                  placeholder: "Indica el VIN del vehículo"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_ErrorMessage, { name: "vin" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_Field, {
                  name: "brand",
                  ref: "brand",
                  as: "select",
                  class: "form-select form-control form-control-sm form-control-solid borderGray",
                  modelValue: _ctx.initialValues.brand,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.initialValues.brand) = $event)),
                  onChange: _ctx.onChangeBrand
                }, {
                  default: _withCtx(() => [
                    _hoisted_10,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.marcas, (mar, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: mar.id
                      }, _toDisplayString(mar.name), 9, _hoisted_11))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_ErrorMessage, { name: "brand" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createVNode(_component_Field, {
                  name: "model",
                  ref: "model",
                  as: "select",
                  class: "form-select form-control form-control-sm form-control-solid borderGray",
                  modelValue: _ctx.initialValues.model,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.initialValues.model) = $event)),
                  onChange: _ctx.onChangeModel
                }, {
                  default: _withCtx(() => [
                    _hoisted_16,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelos, (mod, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: mod.id
                      }, _toDisplayString(mod.name), 9, _hoisted_17))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_ErrorMessage, { name: "model" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createVNode(_component_Field, {
                  name: "year",
                  ref: "year",
                  as: "select",
                  class: "form-select form-control form-control-sm form-control-solid borderGray",
                  modelValue: _ctx.initialValues.year,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.initialValues.year) = $event)),
                  onChange: _ctx.onChangeAnio
                }, {
                  default: _withCtx(() => [
                    _hoisted_22,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.anios, (ani, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: ani.id
                      }, _toDisplayString(ani.name), 9, _hoisted_23))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_ErrorMessage, { name: "year" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createVNode(_component_Field, {
                  name: "version",
                  ref: "version",
                  as: "select",
                  class: "form-select form-control form-control-sm form-control-solid borderGray",
                  modelValue: _ctx.initialValues.version,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.initialValues.version) = $event)),
                  onChange: _ctx.onChangeVersion
                }, {
                  default: _withCtx(() => [
                    _hoisted_28,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.versiones, (ver, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: ver.id
                      }, _toDisplayString(ver.name), 9, _hoisted_29))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_ErrorMessage, { name: "version" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createVNode(_component_Field, {
                  name: "color",
                  ref: "color",
                  as: "select",
                  class: "form-select form-control form-control-sm form-control-solid borderGray",
                  modelValue: _ctx.initialValues.color,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.initialValues.color) = $event)),
                  onChange: _ctx.onChangeColor
                }, {
                  default: _withCtx(() => [
                    _hoisted_34,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colores, (col, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: col.id
                      }, _toDisplayString(col.name), 9, _hoisted_35))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _createVNode(_component_ErrorMessage, { name: "color" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _hoisted_40,
                _createElementVNode("ul", _hoisted_41, [
                  _createElementVNode("li", _hoisted_42, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["btn", _ctx.tipoTransmision == 'Manual' ? 'btn-primary' : 'btn-secondary']),
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.cambiarTransmision('Manual')))
                    }, _hoisted_44, 2)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["btn", 
                      _ctx.tipoTransmision == 'Automática' ? 'btn-primary' : 'btn-secondary'
                    ]),
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.cambiarTransmision('Automática')))
                    }, _hoisted_46, 2)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _hoisted_49,
                _createVNode(_component_Field, {
                  name: "carroceria",
                  ref: "carroceria",
                  as: "select",
                  class: "form-select form-control form-control-sm form-control-solid borderGray",
                  modelValue: _ctx.initialValues.carroceria,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.initialValues.carroceria) = $event)),
                  onChange: _ctx.onChangeCarroceria
                }, {
                  default: _withCtx(() => [
                    _hoisted_50,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carrocerias, (car, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: car.id
                      }, _toDisplayString(car.name), 9, _hoisted_51))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"]),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _createVNode(_component_ErrorMessage, { name: "carroceria" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_54, [
                _hoisted_55,
                _createVNode(_component_Field, {
                  name: "combustible",
                  ref: "combustible",
                  as: "select",
                  class: "form-select form-control form-control-sm form-control-solid borderGray",
                  modelValue: _ctx.initialValues.combustible,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.initialValues.combustible) = $event)),
                  onChange: _ctx.onChangeCombustible
                }, {
                  default: _withCtx(() => [
                    _hoisted_56,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.combustibles, (com, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: com.id
                      }, _toDisplayString(com.type), 9, _hoisted_57))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"]),
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("div", _hoisted_59, [
                    _createVNode(_component_ErrorMessage, { name: "combustible" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_60, [
                _hoisted_61,
                _createVNode(_component_Field, {
                  class: "form-control form-control-sm form-control-solid",
                  type: "text",
                  name: "kilometraje",
                  ref: "kilometraje",
                  modelValue: _ctx.initialValues.kilometraje,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.initialValues.kilometraje) = $event)),
                  autocomplete: "off",
                  placeholder: "000,000 km",
                  onChange: _ctx.addKm
                }, null, 8, ["modelValue", "onChange"]),
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("div", _hoisted_63, [
                    _createVNode(_component_ErrorMessage, { name: "kilometraje" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_64, [
                _hoisted_65,
                _hoisted_66,
                _createElementVNode("ul", _hoisted_67, [
                  _createElementVNode("li", _hoisted_68, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["btn", _ctx.certificado == 'Si' ? 'btn-primary' : 'btn-secondary']),
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.cambiarCertificado('Si')))
                    }, _hoisted_70, 2)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["btn", _ctx.certificado == 'No' ? 'btn-primary' : 'btn-secondary']),
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.cambiarCertificado('No')))
                    }, _hoisted_72, 2)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_73, [
                _hoisted_74,
                _createVNode(_component_Field, {
                  class: "form-control form-control-sm form-control-solid",
                  type: "text",
                  name: "precio",
                  ref: "precio",
                  modelValue: _ctx.initialValues.precio,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.initialValues.precio) = $event)),
                  autocomplete: "off",
                  placeholder: "$ 000,000.00",
                  onChange: _ctx.addMoney
                }, null, 8, ["modelValue", "onChange"]),
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("div", _hoisted_76, [
                    _createVNode(_component_ErrorMessage, { name: "precio" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_77, [
                _hoisted_78,
                _createElementVNode("div", _hoisted_79, [
                  _createElementVNode("span", _hoisted_80, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-secondary btn-sm m-0 fs-2",
                      onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.restarDias && _ctx.restarDias(...args)))
                    }, " - ")
                  ]),
                  _createVNode(_component_Field, {
                    class: "form-control form-control-sm form-control-solid text-center",
                    type: "number",
                    name: "piso",
                    ref: "piso",
                    modelValue: _ctx.initialValues.piso,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.initialValues.piso) = $event)),
                    autocomplete: "off",
                    placeholder: "0"
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("span", _hoisted_81, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary btn-sm m-0 fs-2",
                      onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.sumarDias && _ctx.sumarDias(...args)))
                    }, " + ")
                  ]),
                  _createElementVNode("div", _hoisted_82, [
                    _createElementVNode("div", _hoisted_83, [
                      _createVNode(_component_ErrorMessage, { name: "piso" })
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onInvalidSubmit", "onSubmit", "validation-schema"])
  ]))
}